import { getFormatMessage, isAsyncFunction } from '@/utils/utils'
import { Modal } from 'antd'
import React, { useState } from 'react'
import { TemplateImport } from '.'
import { TemplateImportModalProps, TemplateItem } from '../interface'

export const TemplateImportModal: React.FC<TemplateImportModalProps> = (
  props: TemplateImportModalProps
) => {
  const formatMessage = getFormatMessage()
  const { visible, onVisibleChange, onImport } = props
  const [formResult, setFormResult] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const handleImport = async (items: TemplateItem[]) => {
    setFormResult(false)
    if (isAsyncFunction(onImport)) {
      try {
        setLoading(true)
        await onImport?.(items)
      } finally {
        setLoading(false)
      }
    } else {
      onImport?.(items)
    }
    onVisibleChange?.(false)
  }

  return (
    <Modal
      maskClosable={false}
      destroyOnClose={true}
      title={formatMessage({ id: 'app.template.toolbar.import' })}
      visible={visible}
      okText={formatMessage({ id: 'app.modal.ok' })}
      okButtonProps={{ loading: loading }}
      cancelText={formatMessage({ id: 'app.modal.cancel' })}
      onOk={() => setFormResult(true)}
      onCancel={() => onVisibleChange?.(false)}
      width={400}
    >
      <TemplateImport formResult={formResult} onImport={handleImport} />
    </Modal>
  )
}
